const landingTypesList = [
  '/',
  '/fullPrice',
  '/up',
  '/trial',
  '/up_v2',
  '/intro_offer',
  // '/freetrial',
  // '/anim',
  // '/discount-anim',
];

export default landingTypesList;
